import React, { useState, useEffect } from 'react'
import './editprofilepic.sass'

import { ButtonRed } from '../common/Button'

import { useDispatch, useSelector } from 'react-redux'
import "cropperjs/dist/cropper.css";
import Cropper from "react-cropper";

export default function EditProfilePic({ img, handleImageData, uploading }) {
    const dispatch = useDispatch();
    const [cropper, setCropper] = useState();

    const closeModal = () => {
        dispatch({
            type: 'TOGGLE_CROP_MODAL'
        })
    }

    useEffect(() => {
    //    console.log(cropper)
    }, [cropper])

    return (
        <div>
            <div id="editProfilePicWrapper">
                <div id="editProfilePicModal">
                    <div id="editProfileModalRow">
                        <h3>Crop photo</h3>
                        <img onClick={closeModal} src={require('../../assets/icons/cross.svg')} />
                    </div>
                    <div id="editProfileCropper">
                        {img != null &&
                            <Cropper
                                style={{ height: '500px', width: "100%" }}
                                initialAspectRatio={1}
                                preview=".img-preview"
                                src={img}
                                viewMode={1}
                                aspectRatio={1 / 1}
                                guides={true}
                                minCropBoxHeight={10}
                                minCropBoxWidth={10}
                                background={false}
                                responsive={true}
                                autoCropArea={1}
                                checkOrientation={false}
                                onInitialized={(instance) => {
                                    setCropper(instance);
                                   
                                }}
                            />
                        }
                    </div>
                    <div id="editProfilePicFooter">
                    <ButtonRed handleOnClick={()=>{handleImageData(cropper)}} icon="upload_a.svg" text={uploading ? "UPLOADING" : "SAVE"} />
                    </div>
                </div>
            </div>
        </div>
    )
}
